import {GifActions} from "../constants/gifActions";
import {CategoryActionType} from "../constants/categoryActionType";

const INITIAL_STATE = {
    categories : undefined,
    tagesByCategories :undefined
};


export default function(state = INITIAL_STATE, action) {


    switch (action.type) {

        case CategoryActionType.GET_CATEGORIES :
            return {
                ...state,
                categories: action.payload.categories,
            };
        case CategoryActionType.GET_TAGS_BY_CATEGORIES :
            return {
                ...state,
                tagesByCategories: action.payload.tagesByCategories,
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/category.ts